module.exports = __webpack_public_path__ + "img/product-categories.f9d31b09.svg";